// it contains data scraped from fo-site listing page HTML
import { createAction, createReducer } from '@reduxjs/toolkit';


// 1. Initial state
const initialState = {
  // translations gathered from UBO (Universal Backend Service)
  translations: {},

  // settings gathered from UBO (Universal Backend Service)
  settings: {},

  // data for links about breadcrumb
  linksAboveBreadcrumb: undefined,

  // data for checkboxes ranges in price filter
  priceFilterRangesData: undefined,

  // HTML content (banners, etc.) on the left side below filters
  leftPanelBelowFiltersContent: undefined,

  // HTML content (banners, etc.) below paginator
  bottomPanelBelowPaginatorContent: undefined,

  // UCMS Hierarchy of Universes, categories, markets and segments
  ucmsHierarchy: undefined,

  // SEO configuration used for rendering segment page on server
  seoConfiguration: undefined,

  // contains important log messages from server which are logged to browser console after loading the page in browser
  serverLogMessages: []
};


// 2. Basic actions creators
export const setMultipleStaticData = createAction('listingPage/staticData/setMultipleStaticData');

export const setUcmsHierarchy = createAction('listingPage/staticData/setUcmsHierarchy');

export const addServerLogMessage = createAction('listingPage/staticData/addServerLogMessage');


// 3. Reducer
/* eslint-disable no-param-reassign */
export default createReducer(initialState, {
  [setMultipleStaticData]: (stateDraft, action) => {
    Object.keys(action.payload).forEach((key) => {
      stateDraft[key] = action.payload[key];
    });
  },
  [setUcmsHierarchy]: (stateDraft, action) => {
    stateDraft.ucmsHierarchy = action.payload;
  },
  [addServerLogMessage]: (stateDraft, action) => {
    stateDraft.serverLogMessages.push(action.payload);
  }
});
